module.exports = __webpack_public_path__ + "ecc77c94c12db3f859601039a3cdeb4a.jpg";